module.exports = __webpack_public_path__ + "img/cw.svg";